import { render, staticRenderFns } from "./ListOrderReturn.vue?vue&type=template&id=5e4c4f78&"
import script from "./ListOrderReturn.vue?vue&type=script&lang=js&"
export * from "./ListOrderReturn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports